import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { applyRuntimeEnv } from './app/core/env/runtime-env';

// TODO(auth): outil dev — `?token=<sanctum>` alimente le Bearer avant le
// bootstrap (vérification headless, première mise en route). Remplacé par
// le vrai login Sanctum.
const devToken = new URLSearchParams(window.location.search).get('token');
if (devToken !== null && devToken !== '') {
  window.localStorage.setItem('gisgo-ops-token', devToken);
}

/**
 * Config runtime AVANT bootstrap : un `config.json` posé à côté de l'app par
 * le déploiement écrase les valeurs compilées (cf. runtime-env.ts). Garde-fous :
 * - `no-store` : jamais de config périmée en cache navigateur ;
 * - content-type json exigé : un 404 servi en fallback SPA (index.html,
 *   text/html) est rejeté → on garde l'Env compilé (cas local/dev-server) ;
 * - toute erreur réseau/parse → Env compilé, l'app démarre quand même.
 */
fetch('config.json', { cache: 'no-store' })
  .then((response) =>
    response.ok && (response.headers.get('content-type') ?? '').includes('json')
      ? response.json()
      : null,
  )
  .catch(() => null)
  .then((config: unknown) => {
    if (config !== null) {
      applyRuntimeEnv(config);
    }
    return bootstrapApplication(App, appConfig);
  })
  .catch((err) => console.error(err));
